import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  GeneralTable,
  PricingUsageTable,
  PaymentModelPricingNonUsageTablesFactory,
} from '@components/Numbers/Details/Table';
import { Page500 } from '@containers/ErrorPages';
import { numberApi } from '@reducers/number/number';

export const GeneralTab = ({ did }) => {
  const { payment_model: paymentModel } = useSelector(
    (state) => state.auth.user
  );
  const {
    data: result,
    isLoading,
    status,
  } = numberApi.useGetForGeneralQuery({ did });
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (status === 'rejected') {
    return <Page500 />;
  }
  const PricingNonUsageTable = new PaymentModelPricingNonUsageTablesFactory(
    paymentModel,
    result.type
  ).getTableClass();
  return (
    <>
      <Row>
        <Col>
          <GeneralTable data={[result]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <PricingNonUsageTable data={[result]} />
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <PricingUsageTable data={[result]} />
        </Col>
      </Row>
    </>
  );
};
